import { ControllerExceptionCodes } from 'utils/controllerException';
import Entity from './entity';

export enum ApiErrorLevel {
  Info = 0,
  Warning = 1,
  Error = 2,
}

export class ApiErrorInfo {
  level: ApiErrorLevel;

  code: string | undefined;

  message: string;

  details: string | undefined;

  //internal props
  controllerExceptionCode?: ControllerExceptionCodes | undefined;

  displayMessage?: string | undefined;

  entity?: Entity | undefined;

  constructor() {
    this.level = ApiErrorLevel.Error;
    this.message = '';
  }
}
